import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AIPlanBlueprintPageState {
  editMode: boolean
}

const initialState: AIPlanBlueprintPageState = {
  editMode: false
}

const aiPlanBlueprintSlice = createSlice({
  name: 'aiPlanBlueprint',
  initialState,
  reducers: {
    setEditMode: (state, action: PayloadAction<boolean>) => {
      state.editMode = action.payload
    },
    resetEditMode: state => {
      state.editMode = false
    }
  }
})

export const { setEditMode, resetEditMode } = aiPlanBlueprintSlice.actions

export const selectBlueprintEditMode = (state: { aiPlanBlueprint: AIPlanBlueprintPageState }): boolean => {
  return state.aiPlanBlueprint.editMode
}

export default aiPlanBlueprintSlice.reducer
